import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import {
  glnOrGlnCheckValidator,
  RegexPattern,
  validateGLNCheckDigit,
  validateVatId,
} from '@markant-platform/shared/util-helpers';
import { AddressFormGroup } from '@markant-platform/shared/form';
import { RequiredFields } from '@markant-platform/campaign/model';
import {
  OrganizationFormGroup,
  OrganizationFurtherDataFormGroup,
  UserFormGroup,
} from '@markant-platform/registration/model';
import { Industry, SalutationType } from 'data-model';

const isRequired = (field: keyof RequiredFields, requiredFields?: RequiredFields): ValidatorFn[] => {
  if (!requiredFields) {
    return [Validators.required];
  }
  return requiredFields[field] ? [Validators.required] : [];
};

export function generateOrganizationFurtherDataFormGroup(
  requiredFields?: RequiredFields
): OrganizationFurtherDataFormGroup {
  return new FormGroup(
    {
      gln: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.pattern(RegexPattern.GLN_PATTERN), validateGLNCheckDigit, Validators.required],
      }),
      glnNotAvailable: new FormControl<boolean>(false, {
        nonNullable: true,
      }),
      industry: new FormControl<Industry | null>(null, [...isRequired('industry', requiredFields)]),
      salesTaxId: new FormControl<string>('', [Validators.required, validateVatId]),
      salesTaxNotAvailable: new FormControl<boolean>(false, {
        nonNullable: true,
      }),
      taxNumber: new FormControl<string>({ value: '', disabled: true }),
    },
    [glnOrGlnCheckValidator]
  );
}

export function generateOrganizationFormGroup(requiredFields?: RequiredFields): OrganizationFormGroup {
  const addressGroup = new AddressFormGroup(null, { required: true });
  return new FormGroup({
    name: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(128), Validators.pattern(RegexPattern.XSS_PATTERN)],
    }),
    ...addressGroup.controls,
    phone: new FormControl('', {
      nonNullable: true,
      validators: [Validators.pattern(RegexPattern.PHONE_PATTERN), ...isRequired('organizationPhone', requiredFields)],
    }),
  });
}

export function generateUserFormGroup(): UserFormGroup {
  return new FormGroup({
    salutation: new FormControl<SalutationType | null>(null, {
      validators: [Validators.required],
    }),
    firstname: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(RegexPattern.NAME_PATTERN)],
    }),
    lastname: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(RegexPattern.NAME_PATTERN)],
    }),
    email: new FormControl('', {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.pattern(RegexPattern.EMAIL_PATTERN),
        Validators.pattern(RegexPattern.XSS_PATTERN),
      ],
    }),
  });
}
